import { ReactNode, useCallback, useMemo, useState } from 'react';
import {
  BANNER_ORDER,
  ComposerBannerKey,
  ComposerBannersContext,
  ComposerBannersValue,
} from './composer-banners-context';

export const ComposerBannersProvider = ({ children }: { children: ReactNode }) => {
  const [visibleMap, setVisibleMap] = useState<Record<ComposerBannerKey, boolean>>({
    holiday: false,
    snooze: false,
    ai: false,
  });

  const setVisible = useCallback((key: ComposerBannerKey, next: boolean) => {
    setVisibleMap((prev) => (prev[key] === next ? prev : { ...prev, [key]: next }));
  }, []);

  const value = useMemo<ComposerBannersValue>(
    () => ({
      setVisible,
      hasAnyBanner: visibleMap.holiday || visibleMap.snooze || visibleMap.ai,
      hasBannerBelow: (key) => {
        const index = BANNER_ORDER.indexOf(key);
        return BANNER_ORDER.slice(index + 1).some((below) => visibleMap[below]);
      },
    }),
    [setVisible, visibleMap],
  );

  return (
    <ComposerBannersContext.Provider value={value}>{children}</ComposerBannersContext.Provider>
  );
};
